import { useMemo } from 'react'
import type { BadgeProps } from './Badge.types'
import * as S from './Badge.styles'

const Badge = ({ required, color, variant, ...props }: BadgeProps) => {
  const computedColor = useMemo(() => (required ? 'error' : color), [color, required])
  const computedVariant = useMemo(() => (required ? 'dot' : variant), [variant, required])
  return <S.Badge {...props} color={computedColor} variant={computedVariant} />
}

export default Badge
